"use client";

import Link from "next/link";
import { X } from "lucide-react";
import { useState } from "react";
import { getTeamLogoUrl } from "@/lib/logo-resolver";
import { getHungarianWorldCupTeamName } from "@/lib/world-cup-team-names";

type FavoriteTeamQuickChipTeam = {
  name: string;
  href: string;
  logoUrl: string | null;
  externalTeam?: { crest: string | null } | null;
};

export function FavoriteTeamQuickChip({
  team,
  onUse,
  className = "",
}: {
  team?: FavoriteTeamQuickChipTeam | null;
  onUse?: () => void;
  className?: string;
}) {
  const [hidden, setHidden] = useState(false);

  if (!team || hidden) return null;
  const teamName = getHungarianWorldCupTeamName(team.name) || team.name;

  return (
    <span
      className={`inline-flex max-w-full items-center overflow-hidden rounded-full border border-[#E7E1D7] bg-[#F7F5F1] text-sm font-bold text-[#5F666B] transition hover:border-[#D8D0C3] hover:bg-[#F1ECE4] hover:text-[#1A1A1A] ${className}`}
    >
      <Link href={team.href} onClick={onUse} className="inline-flex min-w-0 items-center gap-1.5 py-1 pl-2.5 pr-1.5">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={getTeamLogoUrl(team)} alt="" className="h-4 w-4 shrink-0 object-contain" loading="lazy" decoding="async" />
        <span className="truncate">{teamName}</span>
      </Link>
      <button
        type="button"
        aria-label="Kedvenc csapat chip elrejtése"
        title="Elrejtés erre a keresésre"
        onClick={() => setHidden(true)}
        className="grid h-7 w-7 shrink-0 place-items-center text-[#5F666B]/70 transition hover:bg-[#E7E1D7]/60 hover:text-[#1A1A1A]"
      >
        <X size={14} aria-hidden="true" />
      </button>
    </span>
  );
}
